import { axiosInstance } from "../../network/apis/index";

const getBrowseByIndustry = async () =>{
    return await axiosInstance.get(`/candidate/companies/Industry/list` );
}

export default {
  getBrowseByIndustry,
};
